module.exports = __webpack_public_path__ + "img/stock1.177a72c0.png";